import add from "date-fns/add";
import isToday from "date-fns/isToday";
import isWeekEnd from "date-fns/isWeekend";

export const HOURS = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
  22, 23,
];

export const LAST_HOUR_OF_DAY = 23;

export const MONTHS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const MILLI = {
  seconds: 1000,
  minutes: 1000 * 60,
  hours: 1000 * 60 * 60,
  halfHours: 1000 * 60 * 30,
  day: 1000 * 60 * 60 * 24,
};

export type TimeInfo = {
  hours: number;
  minutes: number;
  seconds: number;
  milliseconds: number;
};
export type SliceInfo = {
  startTimeInMs: number;
  lenghtInMs: number;
  time: TimeInfo;
  isHour: boolean;
};
export type DaySlices = 5 | 10 | 15 | 30 | 60;
export type DayInfos = {
  date: Date;
  isWeekEnd: boolean;
  isToday: boolean;
};
export const getDates = (start: Date, count: number, hideDays: number[]) => {
  let currentDate = new Date(
    start.getFullYear(),
    start.getMonth(),
    start.getDate()
  );

  let dates: Date[] = [];

  for (let i = 0; i < count; i++) {
    const day = currentDate.getDay();
    const hide = hideDays?.some((d) => d === day);
    if (!hideDays || hideDays.length === 0 || !hide) dates.push(currentDate);
    currentDate = add(currentDate, { days: 1 });
  }

  return dates.map(
    (d) =>
      ({ date: d, isToday: isToday(d), isWeekEnd: isWeekEnd(d) } as DayInfos)
  );
};

export const sliceDay = (sliceLenghtInMs: number) => {
  const nbSections = MILLI.day / sliceLenghtInMs;
  const slices: SliceInfo[] = [];

  for (let i = 0; i < nbSections; i++) {
    const startTimeInMs = i * sliceLenghtInMs;
    slices.push({
      startTimeInMs,
      lenghtInMs: sliceLenghtInMs,
      time: msToTime(startTimeInMs),
      isHour: startTimeInMs % MILLI.hours === 0,
    });
  }
  return slices;
};

export const Digits = (num: number, count = 2) =>
  num.toLocaleString("en-US", {
    minimumIntegerDigits: count,
    useGrouping: false,
  });

export function msToTime(duration: number) {
  let milliseconds = Math.floor((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  return { hours, minutes, seconds, milliseconds };
}

export function getInterval(bound1: Date, bound2: Date): Interval {
  if (bound1 > bound2) {
    return {
      start: bound2,
      end: bound1,
    };
  } else {
    return {
      start: bound1,
      end: bound2,
    };
  }
}

export function parseLocaleDateWithoutTimeString(date: string): Date {
  const parsed = new Date(date);
  parsed.setHours(0, 0, 0, 0);

  return parsed;
}
